/**
 * Internal dependencies
 */
import {
    CURRENT_SUPPORT_RECEIVE,
    CURRENT_SUPPORT_REQUEST,
    CURRENT_SUPPORT_REQUEST_SUCCESS,
    CURRENT_SUPPORT_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentSupport, requestingCurrentSupport} from 'state/current-support/selectors';

/**
 * [description]
 *
 * @param  {[type]} support [description]
 * @return {[type]}         [description]
 */
export const setCurrentSupport = (support) => {
    return {
        type: CURRENT_SUPPORT_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentSupport = () => (dispatch) => {
    dispatch({
        type: CURRENT_SUPPORT_REQUEST,
    });

    return cscom
        .currentSupport()
        .get()
        .then((support) => {
            dispatch({
                type: CURRENT_SUPPORT_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_SUPPORT_RECEIVE,
                payload: {
                    support,
                },
            });
            return support;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_SUPPORT_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_SUPPORT_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentSupportIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const currentSupport = getCurrentSupport(getState());
	const requesting = requestingCurrentSupport(getState());

	if (!currentSupport && requesting == false) {
		return dispatch(requestCurrentSupport(...props))
	}

	return currentSupport;
}
